export default "__VITE_ASSET__5ZOxY7S___"